












































































































import { Emit, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { humanFileSize } from "@/constants";
import FileRenameDialog from "@/custom/page/common/FileRenameDialog.vue";
import FileFlightDateChangeDialog from "@/custom/page/common/FileFlightDateChangeDialog.vue";
import FileProjectChangeDialog from "@/custom/page/common/FileProjectChangeDialog.vue";
import FileGeodeticService from "@/entities/file-geodetic/file-geodetic.service";

@Component({
  components: { FileRenameDialog, FileProjectChangeDialog, FileFlightDateChangeDialog },
})
export default class FileCard extends Vue {
  @Prop() name: string;
  @Prop() flightDate: Date;
  @Prop() img: string; // thumbnail
  @Prop() dateTime: string;
  @Prop() size: number;

  @Prop() selectProp: boolean;
  @Prop() fileId: number;
  @Prop() renameFnc: boolean;
  @Prop() duplicateFnc: boolean;
  @Prop() fileActivated: boolean;

  select = false;
  duplicating = false;

  fileCardNameStyle = {};

  getFileCardNameStyle() {
    if (this.fileActivated === undefined || this.fileActivated) {
      return {
        'background-color': 'white',
      };
    } else {
      return {
        'background-color': 'red',
      };
    }
  }

  @Watch('fileActivated')
  onFileActivatedChange(val, oldVal) {
    if (val) {
      this.fileCardNameStyle = {
        'background-color': 'white',
      };
    } else {
      this.fileCardNameStyle = {
        'background-color': 'red',
      };
    }
  }

  get humanSize() {
    return this.size ? humanFileSize(this.size) : undefined;
  }

  @Emit()
  shiftSelect() {
    return this.select;
  }

  @Emit()
  onFileUpdate(fileId: number) {}

  @Watch('selectProp')
  onSelectPropChange(val, oldVal) {
    this.select = val;
  }

  @Watch('select')
  @Emit()
  onSelectChange(val, oldVal) {}

  @Emit()
  thumbnailImgOnClick() {}

  fileRename = {
    file: {},
    dialog: false,
    onSuccess: () => undefined,
  };

  fileFlightDateChange = {
    file: {},
    dialog: false,
    onSuccess: () => undefined,
  };

  fileProjectChange = {
    file: {},
    dialog: false,
    onSuccess: () => undefined,
  };

  updateFileActivated(fileId: number, activated: boolean) {
    let fileGeodeticService = new FileGeodeticService();
    fileGeodeticService.partialUpdate({ id: fileId, activated: activated }).then(res => {
      this.fileActivated = activated;
      this.onFileUpdate(fileId);
    });
  }

  // Nhân bản file bản đồ: BE chỉ tạo bản ghi mới dùng chung file gốc + mbtiles đã convert nên trả về ngay.
  duplicateFile() {
    if (this.duplicating) {
      return;
    }
    this.duplicating = true;
    let fileGeodeticService = new FileGeodeticService();
    fileGeodeticService
      .duplicate(this.fileId)
      .then(() => {
        this.$bvToast.toast('Nhân bản file thành công! Hãy đổi tên hoặc ngày bay cho bản sao.', {
          toaster: 'b-toaster-top-center',
          title: 'Info',
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
        this.refreshPage();
      })
      .catch(err => {
        this.$bvToast.toast(`Nhân bản file thất bại: ${(err.response && err.response.data && err.response.data.title) || err}`, {
          toaster: 'b-toaster-top-center',
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      })
      .finally(() => {
        this.duplicating = false;
      });
  }

  setProjectThumbnail(fileId: number) {
    let fileGeodeticService = new FileGeodeticService();
    fileGeodeticService.setProjectThumbnail(fileId).then(res => {
      this.$bvToast.toast('Cài đặt ảnh đại diện dự án thành công!', {
        toaster: 'b-toaster-top-center',
        title: 'Info',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000,
      });
    });
  }

  uploadThumbnail() {
    this.$refs.uploader.click();
  }
  @Inject() refreshPage: () => void;
  doUploadThumbnail(uploadThumbnailFile) {
    if (uploadThumbnailFile == null) {
      return;
    }
    let fileGeodeticService = new FileGeodeticService();
    fileGeodeticService.uploadThumbnail(this.fileId, uploadThumbnailFile).then(res => {
      this.$bvToast.toast('Tải ảnh đại diện thành công!', {
        toaster: 'b-toaster-top-center',
        title: 'Info',
        variant: 'success',
        solid: true,
        autoHideDelay: 3000,
      });
      this.refreshPage();
    });
  }
}
